export const leadStatusTypes = {
    OPT_OUT: 'OPT OUT',
    BOUNCED: 'BOUNCED',
    APPROACHED: 'APPROACHED',
    ENGAGED: 'ENGAGED',
    ESCALATED: 'ESCALATED',
    ENDED: 'ENDED',
    QUALIFIED: 'QUALIFIED',
    ASSIGNED_TO_REP: 'ASSIGNED TO REP',
    NEW: 'NEW',
    ASSIGNED: 'ASSIGNED',
    DELETED: 'DELETED'
};

// Key == friendly name, value == BE value
export const leadStatusUI = {
    [leadStatusTypes.NEW]: "NEW",
    [leadStatusTypes.APPROACHED]: leadStatusTypes.APPROACHED,
    [leadStatusTypes.ENGAGED]: leadStatusTypes.ENGAGED,
    [leadStatusTypes.ESCALATED]: leadStatusTypes.ESCALATED,
    [leadStatusTypes.ASSIGNED]: "ASSIGNED_TO_REP",
    [leadStatusTypes.ENDED]: leadStatusTypes.ENDED,
};

// Key == friendly name, value == BE Enum value
export const leadStatusUIEnum = {
    [leadStatusTypes.NEW]: "New",
    [leadStatusTypes.APPROACHED]: "Approached",
    [leadStatusTypes.ENGAGED]: "Engaged",
    [leadStatusTypes.ESCALATED]: "Escalated",
    [leadStatusTypes.ASSIGNED]: "Assigned",
    [leadStatusTypes.ASSIGNED_TO_REP]: "Assigned To Rep",
    [leadStatusTypes.ENDED]: "Ended",
};

export const leadActionKeys = {
    ASSIGN: "ASSIGN",
    ESCALATE: "ESCALATE",
    DISMISS: "END",
    BLOCK: "BLOCK",
    FOLLOWUP: "FOLLOWUP",
    OOO: "OOO",
    DELETE: "DELETE",
    RERUN: "RERUN",
    MARK_AS_WON: "MARK_AS_WON",
    STANDALONE: "STANDALONE",
    IGNORE: "IGNORE"
};

export const statusActions = {
    [leadStatusTypes.OPT_OUT]: [leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.ESCALATE, leadActionKeys.BLOCK, leadActionKeys.FOLLOWUP, leadActionKeys.OOO, leadActionKeys.DELETE, leadActionKeys.RERUN],
    [leadStatusTypes.BOUNCED]: [leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.ESCALATE, leadActionKeys.BLOCK, leadActionKeys.FOLLOWUP, leadActionKeys.OOO, leadActionKeys.DELETE, leadActionKeys.RERUN],
    [leadStatusTypes.ENDED]: [leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.ESCALATE, leadActionKeys.BLOCK, leadActionKeys.FOLLOWUP, leadActionKeys.OOO, leadActionKeys.DELETE, leadActionKeys.RERUN],
    [leadStatusTypes.APPROACHED]: Object.values(leadActionKeys),
    [leadStatusTypes.ENGAGED]: Object.values(leadActionKeys),
    [leadStatusTypes.NEW]: Object.values(leadActionKeys),
    // [leadStatusTypes.QUALIFIED]: [leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.DISMISS, leadActionKeys.ESCALATE, leadActionKeys.BLOCK],
    [leadStatusTypes.ASSIGNED_TO_REP]: [leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.DISMISS, leadActionKeys.ESCALATE, leadActionKeys.BLOCK, leadActionKeys.FOLLOWUP, leadActionKeys.OOO, leadActionKeys.DELETE, leadActionKeys.RERUN, leadActionKeys.MARK_AS_WON],
    [leadStatusTypes.ESCALATED]: [leadActionKeys.DISMISS, leadActionKeys.ASSIGN, leadActionKeys.STANDALONE, leadActionKeys.BLOCK, leadActionKeys.FOLLOWUP, leadActionKeys.OOO, leadActionKeys.DELETE, leadActionKeys.RERUN, leadActionKeys.MARK_AS_WON],
};

export const SESSION_STATUS = {
    LOADING: 'LOADING', UNSET: 'UNSET', ESTABLISHED: 'ESTABLISHED'
};

export const statusReasons = {
    "DISQUALIFIED": {
        showDetails: true,
        tagText: "DISQUALIFIED",
    },
    "WRONG PERSON": {
        showDetails: true,
        tagText: "WRONG PERSON",
    },
    "MEETING SCHEDULED" : {
        displayName: "Meeting Set",
        tagText: "MEETING SET",
    },
    "PLAYBOOK MATCH" : {
        displayName: "Qualified",
        tagText: "QUALIFIED",
    },
    "CONTACT ME LATER" : {
        displayName: "Contact Later",
        tagText: "CONTACT LATER",
    },
    "UPDATED FROM CRM" : {
        displayName: "Updated From CRM",
        tagText: "FROM CRM"
    }
};
